const trimTrailingSlashes = (value = "") => String(value || "").replace(/\/+$/, "");

const browserOrigin = () => {
  if (typeof window === "undefined" || !window.location) return "";
  return trimTrailingSlashes(window.location.origin || "");
};

const browserHost = () => {
  if (typeof window === "undefined" || !window.location) return "";
  return String(window.location.hostname || "").toLowerCase();
};

export const getRealtimeRelayBaseUrl = (fallbackBase = "") => {
  const explicitBase = trimTrailingSlashes(process.env.REACT_APP_TRANSCRIBE_BASE_URL || "");
  if (explicitBase) return explicitBase;

  const host = browserHost();
  if (host === "zerotyping.ai" || host.endsWith(".zerotyping.ai")) {
    return `${browserOrigin()}/realtime-transcribe`;
  }

  return trimTrailingSlashes(fallbackBase);
};

export const getRealtimeRelayWsUrl = (fallbackBase = "") => {
  const explicitWsUrl = trimTrailingSlashes(process.env.REACT_APP_TRANSCRIBE_WS_URL || "");
  if (explicitWsUrl) return explicitWsUrl;

  const relayBase = getRealtimeRelayBaseUrl(fallbackBase);
  return relayBase ? `${relayBase}/transcribe` : "";
};
